








import { Vue, Component, Prop } from 'vue-property-decorator';
import { URIs } from '../../../src_server/common/URIs';
import { WebUtils } from '../../utils/WebUtils';
import { LineAuthParam } from '../../../src_server/param/LineAuthParam';
@Component({ components: {} })
export default class LineRegistButton extends Vue {
  @Prop({ required: true, default: 'co01' })
  building!: string;

  lineLogin() {
    const redirectPath = WebUtils.getQueryItem('redirect', location);
    const param: LineAuthParam = {
      loginOrRegist: 'regist',
      redirect: '/student-info-input-main',
      building: this.building,
      errorBack: '/',
    };
    location.href = URIs.LINE_AUTH_REDIRECT.setQuery(param).path;
  }
}
